import React, { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const KzPage = lazy(() => import('../pages/kz/page'));
const ThankYouPage = lazy(() => import('../pages/thank-you/page'));
const PaymentCallbackPage = lazy(() => import('../pages/payment-callback/page'));
const UpsellPage = lazy(() => import('../pages/upsell/page'));
const MedicalCertificatePage = lazy(() => import('../pages/medical-certificate/page'));
const HomeBPage = lazy(() => import('../pages/home-b/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const Page30 = lazy(() => import('../pages/30/page'));
const Page302 = lazy(() => import('../pages/30-2/page'));
const ThankYouKaspiPage = lazy(() => import('../pages/thank-you-kaspi/page'));
const CertificatePromoPage = lazy(() => import('../pages/certificate-promo/page'));
const HomeB2Page = lazy(() => import('../pages/home-b2/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <Suspense fallback={null}>
        <HomePage />
      </Suspense>
    ),
  },
  {
    path: '/kz',
    element: (
      <Suspense fallback={null}>
        <KzPage />
      </Suspense>
    ),
  },
  {
    path: '/thank-you',
    element: (
      <Suspense fallback={null}>
        <ThankYouPage />
      </Suspense>
    ),
  },
  {
    path: '/payment-callback',
    element: (
      <Suspense fallback={null}>
        <PaymentCallbackPage />
      </Suspense>
    ),
  },
  {
    path: '/upsell',
    element: (
      <Suspense fallback={null}>
        <UpsellPage />
      </Suspense>
    ),
  },
  {
    path: '/medical-certificate',
    element: (
      <Suspense fallback={null}>
        <MedicalCertificatePage />
      </Suspense>
    ),
  },
  {
    path: '/home-b',
    element: (
      <Suspense fallback={null}>
        <Page30 />
      </Suspense>
    ),
  },
  {
    path: '/30',
    element: (
      <Suspense fallback={null}>
        <Page302 />
      </Suspense>
    ),
  },
  {
    path: '/тест',
    element: (
      <Suspense fallback={null}>
        <Page302 />
      </Suspense>
    ),
  },
  {
    path: '/30-2',
    element: (
      <Suspense fallback={null}>
        <Page30 />
      </Suspense>
    ),
  },
  {
    path: '/thank-you-kaspi',
    element: (
      <Suspense fallback={null}>
        <ThankYouKaspiPage />
      </Suspense>
    ),
  },
  {
    path: '/073u',
    element: (
      <Suspense fallback={null}>
        <CertificatePromoPage />
      </Suspense>
    ),
  },
  {
    path: '/home-b2',
    element: (
      <Suspense fallback={null}>
        <HomeB2Page />
      </Suspense>
    ),
  },
  {
    path: '*',
    element: (
      <Suspense fallback={null}>
        <NotFound />
      </Suspense>
    ),
  },
];

export default routes;
